import { combineReducers } from 'redux';

import mensagem from './mensagem/combineReducers';
import erro from './erro/combineReducers';

export default combineReducers({
	mensagem,
	erro,
});
